import ProfileHeader from "./ProfileHeader";
import InsideHeader from "../../components/InsideHeader";
import PasswordManagement from "../password-management/PasswordManagement";
import "./profile.css";

export default function AccountSettings() {
  return (
    <div className="profile-page">
      <InsideHeader
        title="Account Settings"
        subtitle="Manage your account settings here"
        back={false}
      />
      <div className="profile-page-body">
        <ProfileHeader />

        <div className="profile-settings-shell">
          <PasswordManagement />
        </div>
      </div>
    </div>
  );
}
